// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"bd412575","363":"c7e8fc06","414":"3c98a5de","888":"2a988bac"}[chunkId] + ".chunk.css";
};